import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { store, history } from "./app/store";
import { loadUser, OidcProvider } from "redux-oidc";
import userManager from "./util/userManager";
import { ConnectedRouter } from "connected-react-router";
import { Route } from "react-router";
import Callback from "./pages/Callback";
import SilentRenew from "./components/SilentRenew";
import { Log } from "oidc-client";
import { ThemeProvider } from "./components/settings/theme/ThemeContext";

Log.logger = console;
Log.level = process.env.NODE_ENV === "development" ? Log.DEBUG : Log.ERROR;


loadUser(store, userManager);
export const AppVersion = process.env.REACT_APP_MEMBERPORTAL_VERSION;

ReactDOM.render(
	<React.StrictMode>
			<ThemeProvider initialTheme="">
				<Provider store={store}>
					<OidcProvider userManager={userManager} store={store}>
						<ConnectedRouter history={history}>
							<Route path={"/silent_renew"} exact={true} component={SilentRenew} />
							<Route path="/" component={App} />
							<Route path="/callback" exact={true} component={Callback} />
						</ConnectedRouter>
					</OidcProvider>
				</Provider>
			</ThemeProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
